exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SideMenu-module__wrapper___3eIkh{width:324.5px;height:calc(var(--app-height) - 60px);background:#fff;border-left:1px solid #ececec;padding:1rem;display:grid;gap:2rem;align-items:start;align-content:start}.SideMenu-module__wrapper___3eIkh div{max-width:100%;overflow:hidden}@media screen and (min-width:2000px){.SideMenu-module__wrapper___3eIkh{width:384.5px}}.SideMenu-module__wrapper___3eIkh .SideMenu-module__activities___1ijiA{display:grid;gap:1.5rem;max-width:100%}.SideMenu-module__wrapper___3eIkh .SideMenu-module__portfolios___hGsho{display:grid;gap:1rem;max-width:100%}.SideMenu-module__wrapper___3eIkh h2{margin-bottom:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "SideMenu-module__wrapper___3eIkh",
	"activities": "SideMenu-module__activities___1ijiA",
	"portfolios": "SideMenu-module__portfolios___hGsho"
};